import { withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import React, { useEffect, useState } from 'react';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Stepper from '@material-ui/core/Stepper';
import Typography from '@material-ui/core/Typography';
import {NotificationPayload} from "../../../types/Notification";

import { useStyles } from '../styles';
import NotificationFormDetails from './NotificationFormDetails';
import NotificationUserDetails from './NotificationUserDetails';
import Review from './NotificationReview';
import useCustomUserSelected from '../../../Hooks/useCustomUserSelected';
import {selectActiveUsersCount, selectUsers} from "../../../selectors/root";
import {useDispatch, useSelector} from "react-redux";

import * as userRoutines from "../../../sagas/routines/userRoutines";
const steps = ['Overview', 'Users', 'Review'];

const NotificationCreateForm = ({
    activeEvent,
    clearExtractedUsers,
    createNotification,
    distinctUsers,
    history,
    makeDistinctUsersFromCombined,
    match,
    users,
    users_loading,
}: any) => {
    const classes = useStyles();
    const [activeStep, setActiveStep] = useState(0);
    const [textField, setTextField] = useState('');
    const [textEmpty, setTextEmpty] = useState(false);
    const [isPushNotification, setIsPushNotification] = useState(false);
    const [pushNotificationDeeplinkingDestinationCategory, setPushNotificationDeeplinkingDestinationCategory] = useState<"inbox"|"discover" | "moments">("inbox");
    const [selectedDiscoverCard, setSelectedDiscoverCard] = useState();
    const [usersTargetType, setUsersTargetType] = React.useState<'all' | 'custom'>('all')
    const activeUsersCount = useSelector(selectActiveUsersCount);
    const activeUsers = useSelector(selectUsers) || []
const dispatch = useDispatch()
    const handleTextChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = evt.target;
        setTextField(value);
    };

    const toggleIsPushNotification = () => {
        setIsPushNotification(!isPushNotification);
    };
    const userSelectionHook = useCustomUserSelected([], []);
    useEffect(() => {
        userSelectionHook.setUsers(
            users.map((user: any) => {
                return { id: user.id, name: user.name, type: user.type };
            }),
        );
    }, []);
    const handleNext = async () => {
        if (textField === '') {
            setTextEmpty(true);
            return false;
        }


        if (activeStep === 1 ) {
            // "Custom" refers to individuals being selected
            if (usersTargetType === 'custom'){
                makeDistinctUsersFromCombined(userSelectionHook.checked);
            }else {
                const active =   Object.keys(activeUsers).map(key =>  {
                    return {
                       id:key,
                        name: activeUsers[key]
                    }
                })
                dispatch( userRoutines.makeDistinctUsersFromCombined.success(active))
            }
        }

        //On review view
        if (activeStep === 2) {
            let notification: NotificationPayload = {
                eventId: activeEvent,
                recipients: distinctUsers,
                senderUserId: 'AlertUser',
                text: textField,
                deeplinkingCategory:pushNotificationDeeplinkingDestinationCategory,
                discoverCardPath:selectedDiscoverCard ? selectedDiscoverCard : null
            };
            if (!isPushNotification) {
                //If it's a push notification, we leave off isSilent flag completely
                notification = { ...notification, ...{ isSilent: true } };
            }
            //Triggers routine
             createNotification({usersTargetType, notification});
                history.push(`/events/${match.params.id}/notifications`);

        } else {
            setActiveStep(activeStep + 1);
        }
    };

    const handleBack = () => {
        clearExtractedUsers();
        setActiveStep(activeStep - 1);
    };

    return (
        <React.Fragment>
            <Paper className={classes.paper}>
                <Typography align="center" component="h1" variant="h4">
                    Send a message
                </Typography>

                <Stepper activeStep={activeStep} className={classes.stepper}>
                    {steps.map(label => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
                <React.Fragment>
                    {activeStep === steps.length ? (
                        <React.Fragment></React.Fragment>
                    ) : (
                        <React.Fragment>
                            {activeStep === 0 && (
                                <NotificationFormDetails
                                    handleNameChange={handleTextChange}
                                    isPushNotification={isPushNotification}
                                    nameEmpty={textEmpty}
                                    nameField={textField}
                                    pushNotificationDeepLinkingDestination={pushNotificationDeeplinkingDestinationCategory}
                                    selectPushNotificationDeepLinkingDestinationCategory={setPushNotificationDeeplinkingDestinationCategory}
                                    toggleIsPushNotification={toggleIsPushNotification}
                                    selectedDiscoverCard={selectedDiscoverCard}
                                    setSelectedDiscoverCard={setSelectedDiscoverCard}
                                />
                            )}
                            {activeStep === 1 && (
                                <NotificationUserDetails
                                    usersTargetType={usersTargetType}
                                    setSelection={setUsersTargetType}
                                    userSelectionHook={userSelectionHook}
                                    users={users} />
                            )}
                            {activeStep === 2 && (
                                <Review
                                    activeUsersCount={activeUsersCount}
                                    usersTargetType={usersTargetType}
                                    distinctUsers={distinctUsers}
                                    isPushNotification={isPushNotification}
                                    name={textField}
                                    users_loading={users_loading}
                                />
                            )}
                            <div className={classes.buttons}>
                                {activeStep !== 0 && (
                                    <Button className={classes.button} onClick={handleBack}>
                                        Back
                                    </Button>
                                )}
                                <Button
                                    className={classes.button}
                                    color="primary"
                                    onClick={handleNext}
                                    variant="contained"
                                >
                                    {activeStep === steps.length - 1 ? 'Create' : 'Next'}
                                </Button>
                            </div>
                        </React.Fragment>
                    )}
                </React.Fragment>
            </Paper>
        </React.Fragment>
    );
};

export default withRouter(NotificationCreateForm);
